var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { idbStorage } from './idbStorage';
export var useFilterConfigStore = create()(devtools(persist(function (set) { return ({
    filterConfigurations: {},
    setFilterConfiguration: function (filterId, filterConfiguration) {
        return set(function (state) {
            var _a;
            return ({
                filterConfigurations: __assign(__assign({}, state.filterConfigurations), (_a = {}, _a[filterId] = filterConfiguration, _a)),
            });
        });
    },
    setEnabledModule: function (filterId, moduleId, enabled) {
        return set(function (state) {
            var _a, _b;
            var _c, _d;
            return {
                filterConfigurations: __assign(__assign({}, state.filterConfigurations), (_a = {}, _a[filterId] = __assign(__assign({}, state.filterConfigurations[filterId]), { enabledModules: __assign(__assign({}, ((_d = (_c = state.filterConfigurations[filterId]) === null || _c === void 0 ? void 0 : _c.enabledModules) !== null && _d !== void 0 ? _d : {})), (_b = {}, _b[moduleId] = enabled, _b)) }), _a)),
            };
        });
    },
    clearConfiguration: function (filterId, macroNames) {
        return set(function (state) {
            var _a;
            var _b, _c;
            return {
                filterConfigurations: __assign(__assign({}, state.filterConfigurations), (_a = {}, _a[filterId] = __assign(__assign({}, state.filterConfigurations[filterId]), { inputConfigs: Object.fromEntries(Object.entries((_c = (_b = state.filterConfigurations[filterId]) === null || _b === void 0 ? void 0 : _b.inputConfigs) !== null && _c !== void 0 ? _c : {}).filter(function (_a) {
                        var key = _a[0];
                        return !macroNames.includes(key);
                    })) }), _a)),
            };
        });
    },
    removeFilterConfiguration: function (filterId) {
        return set(function (state) { return ({
            filterConfigurations: Object.fromEntries(Object.entries(state.filterConfigurations).filter(function (_a) {
                var key = _a[0];
                return key !== filterId;
            })),
        }); });
    },
}); }, {
    name: 'filter-configuration-store',
    version: 1,
    storage: idbStorage,
    partialize: function (_a) {
        var filterConfigurations = _a.filterConfigurations;
        return ({ filterConfigurations: filterConfigurations });
    },
})));
